import React, { useState, useEffect, useCallback } from "react";
import { useDropzone } from "react-dropzone";
import { Button, Typography, Select, MenuItem, FormControl, InputLabel, Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import Grid from "@mui/material/Grid2";
//import DocumentViewer from "../doc-view/DocumentViewer";
import DocumentInfo from "../doc-view/DocumentInfo";
import { getAuth } from "firebase/auth";
import callApi from "../common/APIClient"

function ProcessDocs() {
  const [pipelines, setPipelines] = useState([]);
  const [pipelineExistsFlag, setPipelineExistsFlag] = useState(false);
  const [selectedPipeline, setSelectedPipeline] = useState(null);
  const [selectedFile, setSelectedFile] = useState(null);
  const [processing, setProcessing] = useState(false);
  const [result, setResult] = useState(null);
  const [resultVisible, setResultVisible] = useState(false);
  const [openFileDialog, setOpenFileDialog] = useState(false);

  // Fetch pipelines from FastAPI
  useEffect(() => {
    const fetchPipelineData = async () => {
      setPipelineExistsFlag(false)
      const auth = getAuth();
      const user = auth.currentUser;
      if (!user) return;
      const token = await user.getIdToken();
      console.log('token inside Process Docs')
      console.log(token)

      const response = await callApi({
        url: "/pipelines/",
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        }
      });

      setPipelines(response.pipelines);
      setPipelineExistsFlag(true)
      
    }
    fetchPipelineData();
  }, []);

  // Handle pipeline selection
  const handlePipelineChange = (event) => {
    setSelectedPipeline(event.target.value);
  };

  // Handle file drop
  const onDrop = useCallback((acceptedFiles) => {
    if (acceptedFiles.length > 0) {
      const file = acceptedFiles[0];
      console.log("Dropped File Size:", file.size); // Debugging step
      setSelectedFile(acceptedFiles[0]);
    }
  }, []);

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    accept: ".pdf, .jpg, .png, .tiff, .docx",
    maxSize: 5000000, // 5MB limit
    multiple: false,
  });

  // Handle file selection from popup
  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      setSelectedFile(file);
      setOpenFileDialog(false);
    }
  };

  // Process documents
  const processDocuments = async () => {
    if (!pipelineExistsFlag && !selectedPipeline) {
      alert("Please select a pipeline before processing.");
      return;
    }

    // All Free Tier Users will get a default pipeline
    // Custom Pipelines are only available registered plan users
    if (!pipelineExistsFlag)
      setSelectedPipeline('default_doc_pipeline')
    
    if (!selectedFile) {
      alert("Please select a file before processing.");
      return;
    }
    setResult(null);
    const formData = new FormData();
    formData.append("file", selectedFile);
    formData.append("pipeline_id", selectedPipeline); // Send pipeline ID
    setProcessing(true);
    try {
      const auth = getAuth();
      const user = auth.currentUser;
      if (!user) return;
      const token = await user.getIdToken();
      
      const response = await callApi({
        url: "/process-docs/",
        method: "POST",
        data: formData,
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
        }
      });

      const doc_data = response.document_data;
      setResult(doc_data);
      setResultVisible(true);
      console.log("Server Response:", response);
    } catch (error) {
      console.error("Processing Document error:", error);
    } finally {
      setProcessing(false);
    }
  };

  return (
    <div className="p-4">
      <Grid container spacing={2}>
        <Grid item size={12}>
          <Typography variant="h6">IDP Processing Pipeline</Typography>
        </Grid>

        {/* Pipeline Selection Dropdown */}
        {pipelineExistsFlag && (
          <>
            <Grid item size={4} md={4}>
              <FormControl fullWidth>
                <InputLabel>Select Pipeline</InputLabel>
                <Select value={selectedPipeline} onChange={handlePipelineChange}>
                  {pipelines.map((pipeline) => (
                    <MenuItem key={pipeline.pipeline_id} value={pipeline.pipeline_id}>
                      {pipeline.pipeline_id}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid size={8}></Grid>
          </>
        )}
        {/* Drag and Drop File Upload */}
        <Grid item size={4}>
          <div
            {...getRootProps()}
            style={{
              border: "2px dashed #ccc",
              padding: "20px",
              textAlign: "center",
              cursor: "pointer",
              borderRadius: "10px",
              backgroundColor: isDragActive ? "#f0f0f0" : "white",
            }}
          >
            <input {...getInputProps()} />
            {isDragActive ? (
              <Typography variant="body1" sx={{ color: "#000", fontWeight: "bold" }}>Drop the file here...</Typography>
            ) : (
              <Typography variant="body1" sx={{ color: "#000", fontWeight: "bold" }}>Drag & drop a file here or click to select</Typography>
            )}
          </div>
        </Grid>

        {/* Display Selected File */}
        {selectedFile && (
          <Grid item size={8}>
            <Typography variant="body2" sx={{ marginTop: 2 }}>
              Selected file: {selectedFile.name}
            </Typography>
          </Grid>
        )}

        {/* File Browse Button 
        <Grid item xs={12} md={4}>
          <Button variant="contained" onClick={() => setOpenFileDialog(true)} sx={{ marginTop: 2 }}>
            Browse Files
          </Button>
        </Grid> */}

        {/* Process Documents Button */}
        <Grid item xs={12} md={4}>
          <Button variant="contained" color="primary" onClick={processDocuments} disabled={processing || !selectedFile} sx={{ marginTop: 2 }}>
            Process Documents
          </Button>
        </Grid>
      </Grid>

      {/* ✅ Render the result only if it exists */}
      {result && (
        <div className="App">
          <DocumentInfo selectedDoc={result} />
        </div>
      )}

      {/* File Selection Dialog */}
      <Dialog open={openFileDialog} onClose={() => setOpenFileDialog(false)}>
        <DialogTitle>Select a File</DialogTitle>
        <DialogContent>
          <input type="file" onChange={handleFileChange} />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenFileDialog(false)} color="primary">
            Cancel
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
export default ProcessDocs;
